export function isBlank(s?: string): s is string {
  return s == null || s.trim() === ''
}

export function isNotBlank(s?: string): s is string {
  return !isBlank(s)
}
